<template>
  <section class="asc-user-dialog--container">
    <asc-dialog
      class="asc-user-dialog"
      :text="title"
      :width="1100"
      :show-dialog="showDialog"
      primary-button-text="Submit"
      :on-primary="onSubmit"
      :primary-available="!isUserReader && valid"
      :on-close="onCloseDialog"
      :loading="edit ? editButtonLoading : newButtonLoading"
      secondary-button-text="Delete"
      :secondary-available="edit ? true : false"
      :on-secondary="null"
    >
      <template v-if="showDialog && !edit">
        <asc-spinner-wrapper :loading="loading">
          <asc-user-dialog-form
            :airlines="airlines"
            :role="role"
            :companies="company"
            :citizenship="citizenship"
            :country="country"
            :report-types="reportTypes"
            :edit="edit"
            :is-user-reader="isUserReader"
            :groups="rolesData"
            class="asc-user-dialog--create"
            @input="handleFormChanged"
          ></asc-user-dialog-form>
        </asc-spinner-wrapper>
      </template>

      <template v-else>
        <asc-spinner-wrapper :loading="loading">
          <asc-tab v-model="model">
            <asc-tab-title title="User Details" :error="!userFieldsValid" />
            <!--
            <asc-tab-title
              title="Email Subscriptions"
              :error="!emailSubscriptionsValid"
            />
            -->
          </asc-tab>
          <asc-tab-body :value="model">
            <asc-tab-item>
              <asc-user-dialog-form
                :user="user"
                :airlines="airlines"
                :role="role"
                :companies="company"
                :citizenship="citizenship"
                :country="country"
                :report-types="reportTypes"
                :edit="edit"
                :is-user-reader="isUserReader"
                :groups="groups"
                class="asc-user-dialog--edit"
                @input="handleFormChanged"
              ></asc-user-dialog-form>
            </asc-tab-item>
            <asc-tab-item class="pa-0">
              <asc-email-subscriptions-tab
                :email-subscription-types="emailSubscriptionTypes"
                :user-email-subscriptions="userEmailSubscriptions"
                :airlines="airlines"
                :master-models="masterModels"
                :analytic-modules="analyticModules"
                :report-types="reportTypes"
                :user="user"
                :is-user-reader="isUserReader"
                class="asc-user-dialog--subscriptions"
                @emailSubscriptionsChange="handleEmailSubscriptionsChange"
                @emailSubscriptionsValid="handleEmailSubscriptionsValidation"
              ></asc-email-subscriptions-tab>
            </asc-tab-item>
          </asc-tab-body>
        </asc-spinner-wrapper>
      </template>
    </asc-dialog>

    <asc-dialog
      text="Confirm"
      :show-dialog="showDeleteDialog"
      :on-close="onCloseDelete"
      primary-button-text="Delete"
      :on-primary="onDeleteUser"
      secondary-button-text="Cancel"
      :on-secondary="onCloseDelete"
    >
      <div v-html="getConfirmText"></div>
    </asc-dialog>
  </section>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscUserDialogForm from './AscUserDialogForm'
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'
import AscEmailSubscriptionsTab from './AscEmailSubscriptionsTab'

import _omit from 'lodash/omit'
import _isMatch from 'lodash/isMatch'

export default {
  name: 'AscUserDialog',

  components: {
    AscDialog,
    AscSpinnerWrapper,
    AscUserDialogForm,
    AscTab,
    AscTabBody,
    AscTabItem,
    AscTabTitle,
    AscEmailSubscriptionsTab,
  },

  /*
  commenting this out for now - remove comment lines when we add email subs tab back

  watch: {
    loading(state) {
      if (
        !state &&
        this.user &&
        this.user.userId &&
        this.userEmailSubscriptions &&
        this.userEmailSubscriptions[this.user.userId].length
      ) {
        this.updatedUserEmailSubscriptions = this.userEmailSubscriptions[
          this.user.userId
        ]
      }
    },
  },
  */

  props: {
    onPrimary: {
      type: Function,
      default: () => {},
    },
    primaryAvailable: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    role: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    company: {
      type: Array,
      default: () => [],
    },
    citizenship: {
      type: Array,
      default: () => [],
    },
    country: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    reportTypes: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: false,
    },
    emailSubscriptionTypes: {
      type: Array,
      default: () => [],
    },
    masterModels: {
      type: Array,
      default: () => [],
    },
    analyticModules: {
      type: Array,
      default: () => [],
    },
    userEmailSubscriptions: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
      default: () => {},
    },
    editButtonLoading: {
      type: Boolean,
      default: false,
    },
    newButtonLoading: {
      type: Boolean,
      default: false,
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
    onCloseDelete: {
      type: Function,
      default: () => {},
    },
    showDeleteDialog: {
      type: Boolean,
      default: false,
    },
    isUserReader: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      emailSubscriptionsValid: true,
      newUser: {},
      updatedUserEmailSubscriptions:
        this.userEmailSubscriptions &&
        this.userEmailSubscriptions[this.user.userId]
          ? this.userEmailSubscriptions[this.user.userId]
          : [],
      tab: 0,
      valid: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.tab
      },
      set(val) {
        this.tab = val
      },
    },
    getConfirmText() {
      return 'You are about to permanently remove this user from the application. Please choose to remove the user or cancel the request.'
    },
    userFieldsValid() {
      if (this.newUser) {
        return !!(
          this.newUser.firstName &&
          this.newUser.lastName &&
          this.newUser.userName &&
          this.newUser.userEmail &&
          this.newUser.companyId &&
          this.newUser.country &&
          this.newUser.airlineIds &&
          this.newUser.airlineIds.length &&
          this.newUser.roleIds &&
          this.newUser.roleIds.length &&
          this.newUser.groupIds &&
          this.newUser.groupIds.length
        )
      }
      return false
    },
    userFieldsChanged() {
      if (this.newUser && this.user) {
        return !(JSON.stringify(this.newUser) === JSON.stringify(this.user))
      }
      return false
    },
    emailSubscriptionsChanged() {
      const ues = this.userEmailSubscriptions[this.user.userId]
      const uues = this.updatedUserEmailSubscriptions
      const uesLen = ues && ues.length ? ues.length : 0
      const uuesLen = uues && uues.length ? uues.length : 0

      if (uesLen && uuesLen)
        return uesLen === uuesLen ? !_isMatch(ues, uues) : true

      if (uuesLen > uesLen || (uuesLen === 0 && uesLen > 0)) return true

      return false
    },
    validate() {
      if (this.edit) {
        return (
          this.userFieldsValid &&
          this.emailSubscriptionsValid &&
          (this.userFieldsChanged || this.emailSubscriptionsChanged)
        )
      } else {
        return this.userFieldsValid
      }
    },
  },

  methods: {
    onCloseDialog() {
      this.onClose()
      this.emailSubscriptionsValid = true
      this.valid = false
      this.tab = 0
      this.updatedUserEmailSubscriptions = []
    },
    onSubmit() {
      this.valid = false
      if (this.edit) {
        this.submitEdit()
        if (!this.editButtonLoading) {
          this.model = 0
        }
      } else {
        this.submitNew()
      }
    },
    submitEdit() {
      this.$emit(
        'submitEdit',
        _omit(
          {
            user: this.newUser,
            emailSubscriptions: this.updatedUserEmailSubscriptions,
          },
          ['user.isFederated', 'user.sendInvite'],
        ),
      )
    },
    submitNew() {
      this.newUser.displayName = `${this.newUser.firstName.trim()} ${this.newUser.lastName.trim()}`
      this.newUser.signInName = this.newUser.userName
      this.$emit('submitNew', _omit(this.newUser, ['userName', 'identityId']))
    },
    handleFormChanged(formData) {
      this.newUser = formData.fields
      this.valid = this.validate
    },
    handleEmailSubscriptionsChange(updatedUserEmailSubscriptions) {
      this.updatedUserEmailSubscriptions = updatedUserEmailSubscriptions
      this.valid = this.validate
    },
    handleEmailSubscriptionsValidation(status) {
      this.emailSubscriptionsValid = status
      this.valid = this.validate
    },
    onDeleteUser() {
      this.$emit('submitDelete', this.user)
    },
  },
}
</script>

<style lang="scss">
.asc-user-dialog--container {
  .asc-user-dialog {
    &--create {
      margin: 15px;
    }

    &--subscriptions {
      min-height: 300px;
    }
  }
}
</style>
